// flash data between page navigation using session storage
// @example
// App.es6.shared.sessionFlash.flash({text: 'I will be only accessible in next page navigation'});
// after navigation:
// App.es6.shared.sessionFlash.getFlash() => { text }
App.namespace('es6.shared.sessionFlash', () => {
  const DEFAULT_KEY = 'session-flash';
  const ignoreFlashes = {}; // ignore getting flashes in current session
  const flashData = {};

  const flash = (data, key = DEFAULT_KEY) => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(data));
      ignoreFlashes[key] = true;
    } catch (err) {}
  };

  const getFlash = (key = DEFAULT_KEY) => {
    if (ignoreFlashes[key]) {
      return null;
    }

    // if data was already access we have it preserved for current page session
    if (flashData[key]) {
      return flashData[key];
    }

    // save last data
    try {
      const flashDataString = window.sessionStorage.getItem(key);
      if (!flashDataString) {
        return null;
      }

      flashData[key] = JSON.parse(window.sessionStorage.getItem(key));

      // clear it so it's not preserved for further navigations
      window.sessionStorage.removeItem(key);

      return flashData[key];
    } catch (err) {
      console.error(err);
    }

    return null;
  };

  return {
    flash,
    getFlash,
  };
});
